import type { ReactNode } from 'react';
import { PortalDots } from '../../components/PortalDots';
import { HeaderLayout } from '../../components/HeaderLayout';
import { Footer } from '../../components/Footer';

export type EnterpriseHubViewProps = {
  status: 'loading' | 'error' | 'ready';
  children?: ReactNode;
};

export function EnterpriseHubView(props: Readonly<EnterpriseHubViewProps>) {
  const { children } = props;
  return (
    <>
      <HeaderLayout />
      <PortalDots />
      {children}
      <Footer />
    </>
  );
}
